import { Container, CssBaseline } from '@mui/material';
import AppFooter from '../components/AppFooter';

import AppTabPanel from '../components/AppTabPanel';
import CommonRoutes from '../routes/CommonRoutes';

const CommonLayout = () => {
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      <CssBaseline />
      <AppTabPanel />
      <Container maxWidth='lg'>
        <CommonRoutes />
      </Container>
      <AppFooter />
    </div>
  );
};

export default CommonLayout;
